import React from 'react'
import injectSheet from 'react-jss'
import styles from './preview.styles'
import classNames from 'classnames'
import PreviewItem from './preview-item/preview-item'
import PendingArea from '../../../pending-area/pending-area'

const Preview = ({
  classes,
  className,
  previews,
  pending,
  notFound,
  onUnsplashSelect
}) => (
  <div className={classNames(classes.container, className)}>
    {pending && <PendingArea className={classes.pendingArea} />}
    {notFound && <div className={classes.notFound}>Nothing was found...</div>}
    {previews && (
      <div className={classes.previews}>
        {previews.map((preview, index) => (
          <PreviewItem
            onClick={onUnsplashSelect}
            className={classes.item}
            index={index}
            key={index}
            id={preview.id}
            author={`${preview.user.first_name} ${preview.user.last_name}`}
            userProfileUrl={preview.user.links.html}
            image={preview.urls.thumb}
          />
        ))}
      </div>
    )}
  </div>
)

export default injectSheet(styles)(Preview)
